import {useEffect, useState, useContext} from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Card,CardBody,CardHeader } from 'reactstrap';
import {HiPencil} from 'react-icons/hi';
import {Button} from '@mui/material';
import { DataCertificado } from '../../interfaces/Certificados';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import '../Icono/cardIcon.css';
import CertificadoService from '../../services/CertificadoService';
import AlertService from '../../services/AlertService';
import { CasUserContext } from '../../services/casUserContext'; 
import { string } from 'yup';
import { certificado } from '../../interfaces/Certificados';
import PdfViewer from './PdfViewer';
import { parse } from 'path';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }),
);

const localBack : string = process.env.REACT_APP_BACK || ''; 

const certificadoService = new CertificadoService();
const alertaService = new AlertService();


export default function BusquedaCertificado(){
    const casUserContext = useContext(CasUserContext);
    const [busqueda, setBusqueda] = useState('');
    const [certificadoEncontrado, setCertificadoEncontrado]= useState<certificado | null>(null);
    const [existeCertificado, setExisteCertificado] = useState(false)
    const [status,setStatus] = useState(0);
    const [pdfBase64, setPdfBase64] = useState('');
    const [pdfResult, setPdfResult] = useState(false);
    const[rutaArchivo, setRutaArchivo] = useState('')

    const getPdf = (id: number | undefined)=> {
        fetch(`${localBack}/api/FileUpload/DescargarEvidencia/${id}`, {
          method: 'GET',
        })
          .then(response => {
            //console.log(response)
            setStatus(response.status );
            return response.json();
          })
          .then(data => {
            if (data !== '') {
                setPdfBase64(`data:application/pdf;base64,${data}`)
                setPdfResult(true);
            } else {
                setPdfResult(false);
            }
          });
      }

    const verificarCertificado=async ()=>{
        //console.log(busqueda);
        if(busqueda===""){
            alertaService.alertaAdvertencia("Campo vacío","Por favor ingrese el código de un certificado a buscar.");
        }else{
            alertaService.showLoading("Buscando Certificado");

            const resp = await certificadoService.BuscarCertificado(busqueda);
            alertaService.hideLoading();
            if(resp.strEstado == 'S') {
                alertaService.alertaExito("Exito","Certificado Encontrado");
                setCertificadoEncontrado(resp.objDatos)
                setExisteCertificado(true);
                getPdf(parseInt(resp.objDatos.refarchivo.split(',')[1]))
                setRutaArchivo(resp.objDatos.ruta);
                
            }else{
                alertaService.alertaAdvertencia("Sin datos","El certificado no existe");
                setExisteCertificado(false);
            }
        }
    }



    const classes = useStyles();
    return (
        <div>
            <div className={classes.root} style={{display:'flex', alignItems:'center', justifyContent:'center'}} >
                <div className='text-right'>
                    <input type="text" className='p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700' placeholder='Código del certificado...' 
                    onChange={e=>setBusqueda(e.target.value)} />
                </div>
                <Button size="small" variant="contained" onClick={verificarCertificado}>Buscar Certificado</Button>
            </div>
            {
                existeCertificado && 
                <div style={{display:"flex", alignItems:"center", justifyContent:"center"}} >
                    {/* <Button style={{margin:'5px'}} href={rutaArchivo} target='blank' variant="contained" >Descargar Certificado</Button> */}
                    <PdfViewer pdfBase64={pdfBase64}/>
                </div>

            }

        </div>
        
    )
}